// extracted by mini-css-extract-plugin
export default {"card":"V7-z"};